/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import SimpleModal from '@modules/admin/common/modal/simpleModal'

const UploadJSON = (props) => {
  const [showModal, setShowModal] = useState(false)
  const [uploadedJSON, setUploadedJSON] = useState(false)
  const [actualFileName, setActualFileName] = useState(false)
  const [actualJSON, setActualJSON] = useState()
  const [error, setError] = useState(false)
  const { input, label, fileName, disabledButton, jsonConf, t } = props

  useEffect(() => {
    if (!!input.value) {
      activeCheck()
      setUploadedJSON(true)
    }
    setActualFileName(fileName[0])
    setActualJSON(jsonConf[0])
  }, [])

  const activeCheck = () => {
    document.querySelector('.JSONcheck').checked = true
  }

  const deleteJSON = () => {
    input.onChange(null)
    setActualFileName('')
    setError(false)
    setUploadedJSON(false)
    setActualJSON(null)
  }

  const onChange = (e) => {
    if (!!e.target.value) {
      const fileReader = new FileReader()
      const nameFile = e.nativeEvent.target.files[0].name
      const nameSplit = nameFile.split('.')
      const extension = nameSplit[nameFile.split('.').length - 1]

      if (extension === 'json') {
        setError(false)
        fileReader.readAsText(e.target.files[0], 'UTF-8')
        fileReader.onload = (e) => {
          let contentFile = e.target.result
          setUploadedJSON(true)
          input.onChange(JSON.parse(contentFile))
          fileName[1](nameFile)
        }
        disabledButton(false)
      } else {
        setError(true)
        setUploadedJSON('')
        disabledButton(true)
      }
    } else if (!!actualFileName) {
      input.onChange(actualJSON)
      fileName[1](actualFileName)
    } else {
      setUploadedJSON('')
      disabledButton(true)
    }
  }

  const optionsModal = () => {
    return (
      <div>
        <p>{t('confirmDeleteJSON')}</p>

        <div className="groupButtonsModalJSON">
          <button className="CancelModalJSON" onClick={() => setShowModal(false) & activeCheck()}>
            {t('Cancelar')}
          </button>
          <button className="ConfirmModalJSON" onClick={() => setShowModal(false) & deleteJSON()}>
            {t('Confirmar')}
          </button>
        </div>
      </div>
    )
  }

  const checkCheckbox = (e) => {
    if (!e.target.checked && (uploadedJSON || !!actualFileName)) {
      setShowModal(true)
    }

    if (!e.target.checked) {
      setError(false)
      document.querySelector('[name="JSONselector"]').value = ''
    }

    e.target.checked && !actualFileName ? disabledButton(true) : disabledButton(false)
  }

  return (
    <div>
      {showModal && (
        <SimpleModal
          title={t('EliminarCustomNavBar')}
          hideModal={() => setShowModal(false) & activeCheck()}
          loading={false}
          className="confirm-JSON-modal"
          template={optionsModal()}
        />
      )}

      <label>¿Custom NavBar/TabBar?</label>
      <input name="JSONcheck" className="JSONcheck" type="checkbox" onChange={checkCheckbox} />
      {actualFileName && (
        <div className="JSONcharged">
          {t('ActualConfiguration')} {actualFileName}
        </div>
      )}

      <div className="JSONloader">
        <p>{label}</p>
        <input name="JSONselector" type="file" accept=".json" onChange={onChange} />
      </div>

      {error && (
        <p className="errorJSON">
          Solo están permitidos archivos con la extensión <b>.json</b>
        </p>
      )}
    </div>
  )
}

export default UploadJSON
